export const SITE_ORIGIN = "https://lunamalies.earthboundmartian.com";
export const SITE_NAME = "Lunamalies";
export const SITE_DESCRIPTION =
  "A public, map-centric archive of catalogued Transient Lunar Phenomena (TLP) from published astronomy catalogs.";
export const ORG_ORIGIN = "https://earthboundmartian.com";
export const ORG_NAME = "Earthbound Martian, LLC";
export const CONTACT_EMAIL = "lunamalies@earthboundmartian.com";
